module.exports = __webpack_public_path__ + "img/clear.64c7f869.svg";